// extracted by mini-css-extract-plugin
module.exports = {"Custom-header":"custom-header_Custom-header__Botal","Custom-header--visible":"custom-header_Custom-header--visible__G_Wr9"};